import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ReactMarkdown from 'react-markdown';
import OnVisible from 'react-on-visible';
import breaks from 'remark-breaks';
import { containers, Grid } from 'style';

const LayoutLineComponent = ({ linelayout }) => (
    <Line id="LayoutLineComponent" className="wrapper">
        <div className="container-fluid">
        <div className="row">
            <LayoutLineCol linelayout={linelayout} />
        </div>
        </div>
    </Line>
);

const LayoutLineCol = ({ linelayout }) => {
    const parsedLayout = JSON.parse(linelayout)
    const layout = parsedLayout && parsedLayout[0];
    if (layout === 'left_full') {
        return (
            <div className="col-xs-12">
                <div className="line"></div>
            </div>
        );
    }
    if (layout === 'right_medium') {
        return (
            <div className="col-xs-12 col-lg-8 col-lg-offset-4">
                <div className="line"></div>
            </div>
        );
    }
    return (
            <div></div>
    );
};

const Line = styled.div`
    .line {
        height: 1px;
        background-color: rgba(0, 0, 0, 0.14);
    }
`;

export default LayoutLineComponent;
